import { atom } from 'recoil';

import { IContractCheckoutProcessDTO } from 'modules/customer/domain/dtos';
import { TPaymentMethodType } from 'shared/domain/entities';

export type TContractCheckoutData = {
  value: number;
  unit?: { id: number };
  customer: { id: number; name: string };
  contractId?: number;
  methods: TPaymentMethodType[];
  process: IContractCheckoutProcessDTO;
  originEvent?: string;
};

export const contractCheckoutAtom = atom<TContractCheckoutData | null>({
  key: 'contractCheckout',
  default: null,
});
